<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrow Ios Left"
      xmlns="http://www.w3.org/2000/svg"
      width="7.188"
      height="14.375"
      class="scaling-svg"
      viewBox="0 0 7.188 14.375"
    >
      <path
        data-name="Icon/Icon/Arrow-ios-left"
        d="M5.985,14.375a1.025,1.025,0,0,1-.8-.383L.227,7.831a1.027,1.027,0,0,1,.011-1.3L5.372.369A1.027,1.027,0,1,1,6.949,1.684L2.354,7.2,6.785,12.7a1.027,1.027,0,0,1-.8,1.671"
        transform="translate(0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowLeftIcon extends Vue {}
</script>

<style>
</style>
